import { render, staticRenderFns } from "./sendback.vue?vue&type=template&id=f4bcabb8&scoped=true"
import script from "./sendback.vue?vue&type=script&lang=js"
export * from "./sendback.vue?vue&type=script&lang=js"
import style0 from "./sendback.vue?vue&type=style&index=0&id=f4bcabb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bcabb8",
  null
  
)

export default component.exports